import { render, staticRenderFns } from "./v-image-popup.vue?vue&type=template&id=b5f0f452"
import script from "./v-image-popup.vue?vue&type=script&lang=js"
export * from "./v-image-popup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports